const triggerInvoca = (): void => {
    if (
        typeof window !== 'undefined'
      && 'Invoca' in window
      && !!window?.Invoca
      && typeof window?.Invoca === 'object'
      && 'PNAPI' in window.Invoca
      && typeof window.Invoca.PNAPI === 'object'
      && window.Invoca.PNAPI
      && 'run' in window.Invoca.PNAPI
      && typeof window?.Invoca?.PNAPI?.run === 'function') {
        window.Invoca.PNAPI.run();
    }
};

export default triggerInvoca;
